import { createFileRoute } from "@tanstack/react-router";

import { ConsoleEmbeddedIdentityPage, consoleContextQueryOptions } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/apps")({
  validateSearch: (search: Record<string, unknown>) => ({
    app_id: typeof search.app_id === "string" ? search.app_id : undefined,
    section: search.section === "settings" || search.section === "test" || search.section === "oidc" ? search.section : undefined,
    ando_status: typeof search.ando_status === "string" ? search.ando_status : undefined,
    ando_session: typeof search.ando_session === "string" ? search.ando_session : undefined,
    ando_proof: typeof search.ando_proof === "string" ? search.ando_proof : undefined,
  }),
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(consoleContextQueryOptions()),
  component: function ConsoleAppsRoute() {
    return <ConsoleEmbeddedIdentityPage appSurface="manage" />;
  },
});
